<ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
</ion-refresher>

@if(isLoading) {
    <div class="ion-padding content-width" *ngFor="let item of [0, 1, 2]">
        <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    </div>
} @else {
    @for (match of matches; track match._id) {
        <app-tie-match-scoreboard *ngIf="!match.dist.transfer?.phone" [match]="match"></app-tie-match-scoreboard>
    } @empty {
        <div class="empty-page">
            <app-empty-page [text]="individuals_placeholder" iconName="tennisball" [secondIcon]="pickleballIcon"></app-empty-page>
        </div>
    }

    <ion-infinite-scroll *ngIf="getMoreMatches" (ionInfinite)="doInfinite($event)">
        <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Load more data..." />
    </ion-infinite-scroll>
}